import React from 'react';
import './footer.css';
import footerMoth from '../../assets/imgs/footerMoth.png';
import footerDecor from '../../assets/imgs/footerDecor.png';
import NavItem from '../common/navitem';

const Footer = () => {
    return ( 
        <>
        <footer id='footer'>
            <div className="footerCont">
                <img className='clothPosition left' src={footerDecor} alt="footer decor" />
                <div className="footerCol">
                    <h3>Quick Links</h3>
                    <ul>
                        <NavItem section="#hero" navitem="Home" />
                        <NavItem section="#life" navitem="Life" />
                        <NavItem section="#works" navitem="Works" />
                    </ul>
                </div>
                <div className="footerCol">
                    <h2>Edgar Allan Poe</h2>
                    <img src={footerMoth} alt="moth with a skull in the middle" />
                    <h5>A digital exploration of the life, works, and dark imagination of Edgar Allan Poe.</h5>
                </div>
                <div className="footerCol">
                    <h3>Quick Links</h3>
                    <ul>
                        <NavItem section="#themes" navitem="Themes" />
                        <NavItem section="#quotes" navitem="Quotes" />
                        <NavItem section="#footer" navitem="Footer" />
                    </ul>
                </div>
                <img className='cloth clothPosition' src={footerDecor} alt="footer decor" />
            </div>
            <h6>Copyright © Jana Mahmoud 2026.</h6>
        </footer>
        </>
     );
}
 
export default Footer;